<template>
  <talentq-view>
    <account-view
      slot="account">
      <account-list/>
      <account-password v-if="account_id"/>
      <account-new v-else/>
    </account-view>
    <project-view
      v-if="account_id"
      slot="project">
      <project-list/>
      <project-editor :key="project_id ? project_id : 'new'"/>
    </project-view>
  </talentq-view>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import TalentqView from "../components/talentq-view";
  import {TALENTQ_STORE_NAMES} from "@/stores_new/vacancy_talentq/constants";
  import AccountView from "../components/account/account-view";
  import AccountList from "./account/account-list";
  import AccountPassword from "./account/account-password";
  import AccountNew from "./account/account-new";
  import ProjectView from "../components/project/project-view";
  import ProjectList from "./project/project-list";
  import ProjectEditor from "./project/project-editor";

  const {mapActions, mapGetters} = createNamespacedHelpers('vacancy_talentq/' + TALENTQ_STORE_NAMES.BINDING);

  export default {
    name: "talentq-controller",
    components: {
      ProjectEditor,
      ProjectList,
      ProjectView,
      AccountNew,
      AccountPassword,
      AccountList,
      AccountView,
      TalentqView
    },
    computed: {
      ...mapGetters(['project_id', 'account_id']),
    },
  }
</script>